exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th[data-v-74ba4c34]{font-weight:700;color:#273246}.fa-sort[data-v-74ba4c34]{color:#bbb;pointer-events:none}.fa-sort-down[data-v-74ba4c34],.fa-sort-up[data-v-74ba4c34]{color:blue;pointer-events:none}.editable-container[data-v-74ba4c34]{position:absolute;top:100px;z-index:9999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74ba4c34","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Datatable.vue
// module id = 570
// module chunks = 0